(function () {
  var SIZE_KEY = "pdp_ring_size_global";
  var HANDLE_KEY = "pdp_ring_size_product";

  function getCurrentProductHandle() {
    var el = document.querySelector("variant-selector");
    if (el && el.data && el.data.handle) return el.data.handle;
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : "";
  }

  function setStoredRingSize(value) {
    if (!value) return;
    try {
      window.sessionStorage.setItem(SIZE_KEY, value);
      window.sessionStorage.setItem(HANDLE_KEY, getCurrentProductHandle());
    } catch (e) {}
  }

  function getStoredRingSizeForNewProduct() {
    try {
      var storedHandle = window.sessionStorage.getItem(HANDLE_KEY) || "";
      var currentHandle = getCurrentProductHandle();
      if (storedHandle && storedHandle === currentHandle) return "";
      var stored = window.sessionStorage.getItem(SIZE_KEY) || "";
      return stored || "";
    } catch (e) { return ""; }
  }

  function hasVariantInUrl() {
    try { return !!new URLSearchParams(window.location.search).get("variant"); } catch (e) { return false; }
  }

  function normalizeSizeToken(s) {
    return String(s == null ? "" : s).replace(/\u00a0/g, " ").trim();
  }

  function getDefaultInStockSize(select) {
    return (select.getAttribute("data-default-in-stock-ring-size") || "6.5").trim();
  }

  function findOptionForSize(select, intended) {
    var want = normalizeSizeToken(intended);
    if (!want) return null;
    var opts = Array.from(select.options);
    return opts.find(function (o) { return normalizeSizeToken(o.value) === want; })
        || opts.find(function (o) { return normalizeSizeToken(o.textContent) === want; })
        || null;
  }

  function isPlaceholderOnly(select) {
    var o = select.options[select.selectedIndex];
    if (!o) return true;
    if (o.value === "") return true;
    return normalizeSizeToken(o.textContent).toLowerCase().indexOf("please") !== -1;
  }

  function setNativeSelectValue(select, value) {
    var match = findOptionForSize(select, value);
    if (!match) return false;
    match.disabled = false;
    select.selectedIndex = Array.from(select.options).indexOf(match);
    select.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  function updateFulfillmentMsg(select, activeSize) {
    var field = select.closest(".variant-selector__option");
    if (!field) return;
    var el = field.querySelector("[data-ring-fulfillment-msg]");
    if (!el) return;
    var def = getDefaultInStockSize(select);
    var ready = el.getAttribute("data-msg-ready") || "Ready to ship.";
    var resize = el.getAttribute("data-msg-resize") || "Please allow 2-4 days for resizing.";
    var current = normalizeSizeToken(activeSize || select.value);
    var isDefault = current === normalizeSizeToken(def);
    el.textContent = isDefault ? ready : resize;
    el.removeAttribute("hidden");
    el.style.display = "";
  }

  function isInsideShopTheLook(select) {
    return !!select.closest(".shop-the-look, .multi-product");
  }

  function applyDefaults(select) {
    // Highest priority: user explicitly picked a size during this page view (survives ALL DOM rebuilds)
    var explicit = window.__ringSizeExplicit || null;
    if (explicit) {
      var explicitMatch = findOptionForSize(select, explicit);
      if (explicitMatch) {
        explicitMatch.disabled = false;
        select.selectedIndex = Array.from(select.options).indexOf(explicitMatch);
        return;
      }
    }

    if (!hasVariantInUrl()) {
      var stored = getStoredRingSizeForNewProduct();
      if (stored) {
        var storedMatch = findOptionForSize(select, stored);
        if (storedMatch) {
          storedMatch.disabled = false;
          select.selectedIndex = Array.from(select.options).indexOf(storedMatch);
        }
      } else {
        var def = getDefaultInStockSize(select);
        var defMatch = findOptionForSize(select, def);
        if (defMatch) {
          select.selectedIndex = Array.from(select.options).indexOf(defMatch);
        }
      }
    }
  }

  function enhanceSelect(select) {
    if (!select || select.dataset.ringEnhanced === "true") return;
    select.dataset.ringEnhanced = "true";

    applyDefaults(select);

    if (isInsideShopTheLook(select)) return;

    var defaultInStock = normalizeSizeToken(getDefaultInStockSize(select));

    var wrapper = document.createElement("div");
    wrapper.className = "ring-size-picker";

    var trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "ring-size-picker__trigger";
    trigger.setAttribute("aria-expanded", "false");

    var current = document.createElement("span");
    current.className = "ring-size-picker__current";
    current.textContent = select.value || "";

    var triggerRight = document.createElement("span");
    triggerRight.className = "ring-size-picker__trigger-right";

    var hideBadges = select.hasAttribute("data-hide-ring-badges");

    var badge = document.createElement("span");
    badge.className = "ring-size-picker__badge";
    if (hideBadges) badge.style.display = "none";

    var icon = document.createElement("span");
    icon.className = "ring-size-picker__icon";
    icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 12.75L15.8333 8.91663L17 10.0833L12 15.0833L7 10.0833L8.16667 8.91663L12 12.75Z" fill="#2F1E19"/></svg>';

    triggerRight.appendChild(badge);
    triggerRight.appendChild(icon);
    trigger.appendChild(current);
    trigger.appendChild(triggerRight);

    var menu = document.createElement("div");
    menu.className = "ring-size-picker__menu";
    menu.hidden = true;

    var grid = document.createElement("div");
    grid.className = "ring-size-picker__grid";
    menu.appendChild(grid);

    Array.from(select.options).forEach(function (opt) {
      if (!opt.value || normalizeSizeToken(opt.textContent).toLowerCase().indexOf("please") !== -1) return;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ring-size-picker__option";
      btn.setAttribute("data-ring-size-value", opt.value);
      btn.textContent = opt.textContent;
      if (normalizeSizeToken(opt.value) === normalizeSizeToken(select.value)) {
        btn.classList.add("is-selected");
      }
      grid.appendChild(btn);
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(menu);
    select.insertAdjacentElement("afterend", wrapper);
    select.classList.add("ring-size-native-hidden");

    // Authoritative user-chosen size — framework cannot touch this.
    wrapper.setAttribute("data-user-ring-size", normalizeSizeToken(select.value));

    function getUserSize() {
      return wrapper.getAttribute("data-user-ring-size") || "";
    }

    function setUserSize(val) {
      wrapper.setAttribute("data-user-ring-size", normalizeSizeToken(val));
    }

    function syncUI() {
      var val = getUserSize();
      current.textContent = val || "";

      wrapper.querySelectorAll("[data-ring-size-value]").forEach(function (btn) {
        btn.classList.toggle("is-selected", normalizeSizeToken(btn.getAttribute("data-ring-size-value")) === val);
      });

      if (!hideBadges) {
        var isInStock = val === defaultInStock;
        badge.textContent = isInStock ? "In Stock" : "Needs Resizing";
        badge.className = "ring-size-picker__badge " + (isInStock ? "ring-size-picker__badge--in-stock" : "ring-size-picker__badge--resize");
      }

      var label = select.closest(".variant-selector__option");
      if (label) {
        var span = label.querySelector('[data-selected-option-label="Ring Size"]');
        if (span) span.textContent = val || "";
      }

      if (!hideBadges) {
        updateFulfillmentMsg(select, val);
      }
    }

    function openMenu() {
      menu.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
    }
    function closeMenu() {
      menu.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
    }

    trigger.addEventListener("click", function () {
      menu.hidden ? openMenu() : closeMenu();
    });

    function getLiveSelect() {
      var vs = wrapper.closest("variant-selector");
      if (vs) {
        var live = vs.querySelector('select[name="Ring Size"], select[data-option-name="Ring Size"]');
        if (live) return live;
      }
      // Wrapper may be detached — search the entire DOM
      var fallback = document.querySelector('variant-selector select[data-option-name="Ring Size"]')
                  || document.querySelector('variant-selector select[name="Ring Size"]');
      return fallback || select;
    }

    function directSync() {
      var vs = wrapper.closest("variant-selector");
      if (!vs) {
        // Wrapper may have been detached — find the Ring Size variant-selector from the DOM
        document.querySelectorAll("variant-selector").forEach(function (el) {
          if (el.querySelector('select[data-option-name="Ring Size"]')) vs = el;
        });
      }
      if (vs && typeof window.__syncAllOptionsFromDom === "function") {
        window.__syncAllOptionsFromDom(vs);
      }
    }

    grid.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-ring-size-value]");
      if (!btn) return;
      var intended = btn.getAttribute("data-ring-size-value");
      var normalizedIntended = normalizeSizeToken(intended);
      setUserSize(intended);
      setStoredRingSize(normalizedIntended);

      // Global variable — survives complete DOM destruction/recreation by the framework
      window.__ringSizeExplicit = normalizedIntended;

      var liveSelect = getLiveSelect();
      var match = findOptionForSize(liveSelect, intended);
      if (match) {
        match.disabled = false;
        liveSelect.selectedIndex = Array.from(liveSelect.options).indexOf(match);
      }

      directSync();
      syncUI();
      closeMenu();

      setTimeout(function () {
        var ls = getLiveSelect();
        var val = getUserSize();
        var m = findOptionForSize(ls, val);
        if (m) {
          m.disabled = false;
          ls.selectedIndex = Array.from(ls.options).indexOf(m);
        }
        directSync();
      }, 50);
    });

    select.addEventListener("change", function () {
      syncUI();
    });

    document.addEventListener("click", function (e) {
      if (!wrapper.contains(e.target)) closeMenu();
    });

    syncUI();

    setTimeout(function () {
      var ls = getLiveSelect();
      var val = getUserSize();
      if (val) {
        var m = findOptionForSize(ls, val);
        if (m) {
          m.disabled = false;
          ls.selectedIndex = Array.from(ls.options).indexOf(m);
        }
      }
      ls.dispatchEvent(new Event("change", { bubbles: true }));
    }, 0);
  }

  function isRingSizeSelect(sel) {
    if (sel.name === "id" || !sel.name) return false;
    var label = (sel.getAttribute("data-option-name") || sel.name || "").toLowerCase();
    return label.indexOf("ring") !== -1 && label.indexOf("size") !== -1;
  }

  function init() {
    document.querySelectorAll(".variant-selector select").forEach(function (sel) {
      if (isRingSizeSelect(sel)) enhanceSelect(sel);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  requestAnimationFrame(init);
  setTimeout(init, 160);

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      if (!added) continue;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === "SELECT" && isRingSizeSelect(node)) {
          enhanceSelect(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll(".variant-selector select").forEach(function (sel) {
            if (isRingSizeSelect(sel)) enhanceSelect(sel);
          });
        }
      }
    }
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
